import styled from "@emotion/styled";
import { colorGuide } from "../../theme/colors";

export const ChipContainer = styled.button<{ isSelected: boolean }>`
  display: inline-flex;
  padding: 2px 4px;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid
    ${({ isSelected }) =>
      isSelected
        ? colorGuide.lightComponents.filterChips.selected.border
        : colorGuide.lightComponents.filterChips.unSelected.border};
  background-color: ${({ isSelected }) =>
    isSelected
      ? colorGuide.lightComponents.filterChips.selected.background
      : colorGuide.lightComponents.filterChips.unSelected.background};
  color: ${({ isSelected }) =>
    isSelected
      ? colorGuide.lightComponents.filterChips.selected.color
      : colorGuide.lightComponents.filterChips.unSelected.color};
`;

export const IconWrapper = styled.div`
  display: flex;
  width: 12px;
  height: 12px;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
`;

export const ChipIcon = styled.i`
  font-size: 12px;
`;
